
import log from 'salvo-lite/log'
import * as jQuery from 'jquery'

class CartVariations {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const selectElement = this._elem.querySelectorAll('.cart_item_variants')

        for (const select of selectElement) {
            select.addEventListener('change', () => {
                const previousVariantID = select.dataset.previousVariant || ''
                this.updateCart(select.value, previousVariantID)
            })
        }
    }

    updateCart (selectedVariantID, previousVariantID) {
        const allSelects = document.querySelectorAll('.cart_item_variants')

        let totalQty = 0

        for (const item of allSelects) {
            const dataQty = item.dataset.originalQty
            if (item.value === selectedVariantID) {
                totalQty += Number(dataQty)
            }
        }

        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
            updates: {
                [previousVariantID]: 0,
                [selectedVariantID]: totalQty
            }
        }).done(() => {
            window.location.reload()
        }).fail((error) => {
            console.error(error.status)
            console.error(error.responseText)
        })
    }
}

export default CartVariations



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CartVariations.js